import styled from 'styled-components';
import { Icon } from '@blueprintjs/core';

export const ReviewImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 10px;
`;

export const ReviewImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const ReviewImageOverlayIcon = styled(Icon)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000094;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
`;
